import { render } from "./StatsLanguageCount.vue?vue&type=template&id=7838cd28"
import script from "./StatsLanguageCount.vue?vue&type=script&lang=js"
export * from "./StatsLanguageCount.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fae/dev/grazer/grazer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__